import { FC, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Spin } from 'antd'
import { router } from './router'
import { initAuth } from './features/auth/utils/authInit'
import BrandLoading from './components/common/BrandLoading'
import { GlobalLoading } from './components/common/GlobalLoading';

// 全局设置 Antd Spin 默认 indicator 为品牌 Loading
Spin.setDefaultIndicator(<BrandLoading size="sm" />);

const App: FC = () => {
  useEffect(() => {
    // Initialize authentication when app loads
    initAuth()
  }, [])

  return <RouterProvider router={router} fallbackElement={<GlobalLoading />} />
}

export default App 